import { render } from "./AdminPanelAchievement.vue?vue&type=template&id=13e62c47&scoped=true&ts=true"
import script from "./AdminPanelAchievement.vue?vue&type=script&lang=ts"
export * from "./AdminPanelAchievement.vue?vue&type=script&lang=ts"

import "./AdminPanelAchievement.vue?vue&type=style&index=0&id=13e62c47&lang=scss&scoped=true"

import exportComponent from "/home/marcin/www/orchidea-event-services/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e62c47"]])

export default __exports__